import { useTheme as p } from "@chakra-ui/system";
const u = (t, o = 1) => {
  const [s, n, r] = (t == null ? void 0 : t.match(/\w\w/g).map((c) => parseInt(c, 16))) ?? [];
  return `rgba(${s},${n},${r},${o})`;
}, l = (t) => t.split("(").pop().split(")")[0], f = (t) => {
  const { focusRingOnLight: o, focusRingDefault: s } = p(), n = {
    outline: "2px solid transparent",
    outlineOffset: "4px"
  }, r = u(t), c = l(r).split(","), [e, a, i, g] = c;
  return {
    boxShadow: e * 0.299 + a * 0.587 + i * 0.114 + (1 - g) * 255 < 90 ? s : o,
    ...n
  };
}, m = (t) => `${t.replace(/[_*]/g, "")}.`;
export {
  u as convertHexToRgba,
  f as getFocusIndicator,
  l as getRgbaValues,
  m as stripMarkdownAndAddPeriod
};
